import { useState, useEffect } from "react";
import sleepGuideMain from "@/assets/images/sleepGuide/sleepGuide.png";
import Icons, { Checkmark } from "@/assets/icons";
import { CircleIcon, Line } from "@/components/UI";
import downloadPdf from "@/assets/icons/download-pdf.svg";
import SleepGuideModal from "./SleepGuideModal";
import { pushEvent } from "@/utils/gtm";

const SleepGuideContent = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    const isSleepGuideAd =
      new URLSearchParams(window.location.search).get("type") === "ad";
    if (isSleepGuideAd) {
      pushEvent("sleep_guide_started");
    }
  }, []);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <SleepGuideModal isOpen={isModalOpen} onOpenChange={setIsModalOpen} />

      <div
        key="sleep-guide-visuals"
        className="mx-auto mb-6.5 flex w-full max-w-[500px] flex-col items-center gap-3 pt-15 md:mb-9"
      >
        <CircleIcon
          src={Icons.Gift}
          className="h-14 w-14 bg-[#B789FF] md:h-20 md:w-20"
          iconClassName="md:max-w-[40px] md:max-h-[40px]"
        />

        <div className="space-y-4">
          <h1 className="text-center text-2xl font-medium text-[#2A1B4D] md:text-3xl">
            Jūsų dovana už prenumeratą – praktinis miego gidas
          </h1>
          <div className="text-grey-600 max-w-[480px] space-y-3 text-sm leading-relaxed md:text-base">
            <p>
              Šis gidas - tai unikali galimybė gauti išsamias, moksliškai
              pagrįstas miego rekomendacijas, parengtas gyd. Vaivos
              Zinkevičiūtės-Balsės, remiantis naujausiais miego medicinos
              tyrimais. Tai apjungtos mokslinių publikacijų analizės, klinikinė
              patirtis ir ekspertinės gydytojos įžvalgos.
            </p>
            <p>
              Gide rasite aiškų miego veikimo mechanizmų paaiškinimą,
              dažniausias miego sutrikimų priežastis bei testą identifikuoti
              savosioms su rekomendacijomis, padedančiomis veiksmingai gerinti
              savo poilsio kokybę.
            </p>
          </div>
        </div>

        <div className="w-full max-w-[516px] overflow-hidden rounded-2xl sm:mt-2">
          <img src={sleepGuideMain} alt="Miego gidas" className="w-full" />
        </div>
      </div>

      <div
        key="sleep-guide-actions-features"
        className="mx-auto flex w-full max-w-[576px] flex-col items-center px-7.5 md:space-y-4"
      >
        <div
          onClick={handleOpenModal}
          style={{ position: "relative", paddingRight: "48px" }}
          className="group bg-dark flex w-min cursor-pointer items-center gap-[10px] rounded-[40px] p-2 pr-[40px] hover:enabled:brightness-95 md:gap-[14px]"
        >
          <span
            style={{ lineHeight: "40px" }}
            className="text-sand flex-nowrap px-4 font-medium whitespace-nowrap md:text-lg"
          >
            Gauti miego gidą
          </span>
          <div
            style={{
              position: "absolute",
              right: "8px",
              transition: "all 0.3s",
            }}
            className="bg-sand flex h-[40px] w-[40px] items-center justify-center rounded-full group-hover:w-[calc(100%-16px)]"
          >
            <img src={downloadPdf} alt="" />
          </div>
        </div>

        <div className="w-full">
          <Line />
        </div>

        <div className="mb-10 w-full space-y-6 text-left">
          <h2 className="text-lg font-medium text-[#2A1B4D] md:text-xl">
            Ką rasite Telomeros miego gide?
          </h2>

          <ul className="space-y-4">
            {[
              "Sužinok, kodėl nepailsi net miegodamas",
              "Identifikuojamos pagrindinės miego sutrikimų priežastys",
              "Aiškūs dienos ir nakties optimizavimo modelis",
              "Sprendimai paremti fiziologija",
            ].map((feature, index) => (
              <li key={index} className="flex items-center gap-4">
                <div className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg bg-[#538A44]">
                  <Checkmark className="h-4 w-4 text-white" />
                </div>
                <span className="text-grey-700 text-sm font-medium md:text-base">
                  {feature}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default SleepGuideContent;
